import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { AppState } from '../../../../../../../types/store';
import { isCurrentUserProfileOwner } from '../../../../../../selectors/users';
import { pushModal } from '@wix/da-shared-react/pkg/Modals/redux/actionCreators';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';

import { Props } from './TierContentSubmit';

export type StateProps = Pick<Props, 'isOwner'>;
export type DispatchProps = Pick<Props, 'onClick'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  isOwner: isCurrentUserProfileOwner(state),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
  dispatch,
  props
) => ({
  onClick: () => {
    if (!props.tier) {
      return;
    }

    dispatch(
      pushModal(ModalType.DEVIATION_SUBMIT, {
        params: { tierId: props?.tier?.deviationId },
      })
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps);
